class SwitchPanelController {
    $onInit() {
        this.contentSwitcherCtrl.register(this.names);
    }
}

const switchPanelComponent = {
    controller: SwitchPanelController,
    template: '<div class="ctx-switch-panel" ' +
        'ng-class="[$ctrl.contentSwitcherCtrl.getPosition($ctrl.names), $ctrl.contentSwitcherCtrl.isActive($ctrl.names) ? \'active\' : \'\']">' +
        '<div ng-class="{\'ctx-switch-panel-content\' : $ctrl.contentSwitcherCtrl.animateSwitcher}" ng-if="$ctrl.contentSwitcherCtrl.isActive($ctrl.names)" ng-transclude></div>' +
        '</div>',
    transclude: true,
    replace: true,
    scope: {},
    bindings: {
        names: '@name',
        destroy: '@'
    },
    require: {
        contentSwitcherCtrl: '^ctxContentSwitcher'
    }
};

module.exports = switchPanelComponent;


// WEBPACK FOOTER //
// ./src/shared/ctxContentSwitcher/ctxSwitchPanel.component.js